import { render, staticRenderFns } from "./SeparationAnxietyDescription.vue?vue&type=template&id=bb7db69c&scoped=true&"
import script from "./SeparationAnxietyDescription.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyDescription.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyDescription.vue?vue&type=style&index=0&id=bb7db69c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7db69c",
  null
  
)

export default component.exports